import React from 'react'
import PropTypes from 'prop-types'

import styles from './PriceSlider.css'

import { PRICE_FILTER } from 'constants/filtering'
import SliderControl from 'components/SliderControl'
import { Price } from 'components'

class PriceSlider extends React.PureComponent {
  static formatPrice (value = 0) {
    const str = value.toString()
    let [integer, fraction] = str.split('.') // eslint-disable-line prefer-const
    if (!fraction) {
      fraction = '00'
    } else if (fraction.length === 1) {
      fraction = `${fraction}0`
    }

    return `${integer}.${fraction}`
  }

  constructor (props) {
    super(props)

    const {initialMinPrice, initialMaxPrice} = props
    this.state = {
      minPrice: initialMinPrice,
      maxPrice: initialMaxPrice
    }
    this.handleSliderChange = this.handleSliderChange.bind(this)
  }

  render () {
    const {values} = this.props
    const {minPrice, maxPrice} = this.state
    const formattedMinPrice = PriceSlider.formatPrice(minPrice)
    const formattedMaxPrice = PriceSlider.formatPrice(maxPrice)
    const classNames = {
      wrapper: styles.price,
      bigPrice: styles.bigPrice,
      smallPrice: styles.smallPrice
    }
    const enDash = '–'
    return (
      <div>
        <div className={styles.label}>
          €<Price value={formattedMinPrice} classNames={classNames} />
          <span className={styles.separator}>{enDash}</span>
          {values.indexOf(maxPrice) === values.length - 1 && '> '}
          €<Price value={formattedMaxPrice} classNames={classNames} />
        </div>
        <SliderControl
          values={values}
          onChange={this.handleSliderChange}
          minValue={minPrice}
          maxValue={maxPrice}
        />
      </div>
    )
  }

  handleSliderChange ({minValue, maxValue}) {
    const prices = {
      minPrice: minValue,
      maxPrice: maxValue
    }
    this.setState(prices)
    this.props.onChange(prices)
  }
}

PriceSlider.defaultProps = {
  values: PRICE_FILTER.OPTIONS,
  initialMinPrice: PRICE_FILTER.OPTIONS[0],
  initialMaxPrice: PRICE_FILTER.OPTIONS[PRICE_FILTER.OPTIONS.length - 1]
}

PriceSlider.propTypes = {
  values: PropTypes.arrayOf(PropTypes.number),
  initialMinPrice: PropTypes.number,
  initialMaxPrice: PropTypes.number,
  onChange: PropTypes.func.isRequired
}

export default PriceSlider
